import { initFederation } from '@angular-architects/native-federation-v4';
import { environment } from './environments/environment';

// Canonical Angular Native Federation v4 host bootstrap: use the ANGULAR ADAPTER's initFederation
// (@angular-architects/native-federation-v4), which bridges to the orchestrator under the hood
// (version resolution, share scopes, caching) and wires the Angular integration.
//
// loadRemoteModule is threaded from the resolved promise into DI via the LOAD_REMOTE_MODULE token
// (see bootstrap.ts / app.server.module.ts). Note: zone-based change detection is enabled
// explicitly via provideZoneChangeDetection() in AppModule — Angular 21 defaults ZONELESS_ENABLED
// to true, so without it NgZone falls back to NoopNgZone and automatic change detection is dead.
function registerSharedLocales(): void {
  const imports = {
    '@angular/common/locales/id': new URL('assets/locale/angular-common-id.mjs', document.baseURI).href,
  };
  const existing = document.querySelector('script[type="importmap-shim"]');
  if (existing && existing.textContent) {
    try {
      const map = JSON.parse(existing.textContent);
      map.imports = { ...(map.imports || {}), ...imports };
      existing.textContent = JSON.stringify(map);
      return;
    } catch {
      /* fall through to a supplementary map */
    }
  }
  const script = document.createElement('script');
  script.type = 'importmap-shim';
  script.textContent = JSON.stringify({ imports });
  document.head.appendChild(script);
}

initFederation(
  { alorMfe: environment.mfeRemoteEntry },
  {
    hostRemoteEntry: './remoteEntry.json',
  },
)
  .then(({ loadRemoteModule }) => {
    registerSharedLocales();
    return import('./bootstrap').then((m) => m.bootstrap(loadRemoteModule));
  })
  .catch((err) => console.error(err));
